import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

const useStyles = makeStyles({
  root: {
    minWidth: 200,
    maxWidth: 320,
    background: '#00BBBB',
    maxHeight: 150,
    minHeight: 150,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 20,
  },
  color: {
    color: "#FFFFFF"
  }
});

const DetailsCard = (props) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
      {props.icon}

        <h4 style={{color: 'white'}}>{props.text}</h4>
        <h2 style={{color: 'white'}}>{props.number}</h2>
      </CardContent>
    </Card>
  );
}

const mapDispatchToProps = (props, ownProps) => ({
})

const mapStateToProps =(state, ownProps, number)  =>({
      text: ownProps.text,
      icon: ownProps.icon,
      number: ownProps.number
    })

export default connect(mapStateToProps,mapDispatchToProps)(DetailsCard);